import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-b-x16" }
const _hoisted_2 = { class: "cws" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "note__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", null, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#svg-alert" })
  ])
], -1 /* HOISTED */)
const _hoisted_4 = ["innerHTML"]

import { PropType, computed } from 'vue'
import { AlertColour } from '../../types/enums'
import type { StatusAlert } from './../../types'
import { getCurrentCulture } from './../../utilities/culture-helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusAlert',
  props: {
  statusAlert: {
    type: Object as PropType<StatusAlert>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const { cultureShortCode } = getCurrentCulture()
const alertThemeClass = computed<string>(() => {
  switch (props.statusAlert.colour) {
    default:
      return ''
    case AlertColour.Red:
      return 'note--danger'
    case AlertColour.Amber:
      return 'note--alert'
    case AlertColour.Green:
      return 'note--info'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.statusAlert.message[_unref(cultureShortCode)])
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['note', alertThemeClass.value])
          }, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "note__text",
              innerHTML: __props.statusAlert.message[_unref(cultureShortCode)]
            }, null, 8 /* PROPS */, _hoisted_4)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})